import { Box, Stack, styled } from '@mui/material';

export const HeaderContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 30px 0 30px;
  align-items: flex-start;
`;

export const CreateSectionsLayoutsText = styled(Box)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 16px;
`;

export const ActionButtonsContainer = styled(Stack)`
  flex-shrink: 0;
`;
